module.exports = __webpack_public_path__ + "img/whitefilter.816bffa7.svg";